import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "landing-hero" }
const _hoisted_2 = {
  width: "0",
  height: "0",
  "aria-hidden": "true",
  focusable: "false",
  class: "hero-blur-def"
}
const _hoisted_3 = {
  id: "reelMotionBlur",
  x: "-10%",
  y: "-70%",
  width: "120%",
  height: "240%",
  "color-interpolation-filters": "sRGB"
}
const _hoisted_4 = {
  ref: "blurG",
  in: "SourceGraphic",
  stdDeviation: "0 0"
}
const _hoisted_5 = { class: "live-badge" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "hero-sub text-medium-emphasis" }
const _hoisted_9 = { class: "hero-ctas" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("defs", null, [
        _createElementVNode("filter", _hoisted_3, [
          _createElementVNode("feGaussianBlur", _hoisted_4, null, 512)
        ])
      ])
    ])),
    _createVNode(_component_v_container, { class: "landing-hero__inner pa-0" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_icon, {
            icon: "mdi-star-four-points",
            size: "13"
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.badge), 1)
        ]),
        _createElementVNode("h1", {
          ref: "slot",
          class: _normalizeClass(["hero-headline hero-slot", { 'hero-slot--spinning': _ctx.spinning }]),
          tabindex: "0",
          role: "button",
          title: "Shuffle titles",
          "aria-label": _ctx.headlines[_ctx.current].plain,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.spin && _ctx.spin(...args))),
          onKeydown: [
            _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.spin && _ctx.spin(...args)), ["prevent"]), ["enter"])),
            _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.spin && _ctx.spin(...args)), ["prevent"]), ["space"]))
          ]
        }, [
          _createElementVNode("span", {
            ref: "reel",
            class: _normalizeClass(["hero-reel", { 'is-spinning': _ctx.spinning }]),
            "aria-hidden": "true"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seq, (h, k) => {
              return (_openBlock(), _createElementBlock("span", {
                key: k,
                class: "hero-line"
              }, [
                _createElementVNode("span", {
                  class: "hl-inner",
                  innerHTML: _ctx.headlines[h].html
                }, null, 8, _hoisted_7)
              ]))
            }), 128))
          ], 2)
        ], 42, _hoisted_6),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.sub), 1),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_btn, {
            color: "msq-yellow",
            variant: "flat",
            height: "48",
            class: "hero-btn px-6",
            "append-icon": "mdi-arrow-right",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('primary')))
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Start building ")
            ])),
            _: 1,
            __: [5]
          }),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "outlined",
            height: "48",
            class: "hero-btn px-6",
            "append-icon": "mdi-arrow-right",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('secondary')))
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode(" Watch it build a squad ")
            ])),
            _: 1,
            __: [6]
          }),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "hero-meta text-disabled" }, "No card. No call.", -1))
        ])
      ]),
      _: 1
    })
  ]))
}